var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 60",
    style: {
      enableBackground: "new 0 0 52 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;}\n\t.st1{fill:none;stroke:#000000;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#CAE1DA;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic_Img_Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic_Img_Info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_graphic_Img"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "19.2,4 26.8,11.6 27.4,10.7 20.6,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,20.2 14.2,30.5 14.8,29.7 3.9,18.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.2,4 30,6.8 30.6,5.9 28.6,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.2,4 28.4,9.2 29,8.3 24.6,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.2,4 31.6,4.4 31.9,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,16.2 15.8,28.1 16.4,27.3 3.9,14.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,28.1 11.1,35.3 11.6,34.4 3.9,26.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,4 3.9,4.5 20.6,21 21.1,20.2 4.8,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,36.1 7.9,40 8.4,39.2 3.9,34.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,8.3 19,23.4 19.6,22.5 3.9,6.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,32.1 9.5,37.6 10,36.8 3.9,30.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,39.9 6.4,42.3 6.9,41.5 3.9,38.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,43.9 4.8,44.7 5.3,43.9 3.9,42.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.4,4 23.7,16.3 24.3,15.4 12.8,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.4,4 25.3,13.9 25.9,13 16.8,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.4,4 22.2,18.6 22.7,17.8 8.8,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,12.3 17.4,25.8 18,24.9 3.9,10.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,24.1 12.7,32.9 13.2,32 3.9,22.7  "
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 39,
    height: 51
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    className: "st2",
    cx: 10,
    cy: 37,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-19",
    x: 6,
    y: 7,
    className: "st2",
    width: 14,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    className: "st2",
    width: 20,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st2",
    cx: 39,
    cy: 47,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "st3",
    d: "M39.1,40c0.5,0,0.9,0.1,1.3,0.4c0.4,0.2,0.5,0.7,0.5,1.3s-0.2,1.1-0.5,1.3c-0.4,0.2-0.8,0.4-1.3,0.4 s-1-0.1-1.3-0.4c-0.4-0.2-0.5-0.7-0.5-1.3s0.2-1.1,0.5-1.3C38.2,40.1,38.6,40,39.1,40z M40.7,44.6v8.7h0.8V54h-5v-0.7h0.8v-8.7 H40.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notification-info.f5c34028352d850def6510fb2122f56c.svg";
export { ForwardRef as ReactComponent };